import { DWImportTable } from 'src/components/import-table';
import { registerExtComponent } from '@alife/cn-lowcode-utils';

registerExtComponent(DWImportTable.displayName, DWImportTable);

export default DWImportTable;
export { DWImportTable };
